import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import {
  ROUTE_STATE_LOCAL_FORECASTS,
  ROUTE_STATE_LOCAL_FORECASTS_DETAILS,
  SCOPE_STATE_LOCAL_FORECASTS,
} from '../../constants';
import { AddToPipelineConsumer, AddToPipelineProvider } from '../../contexts/AddToPipelineContext';
import Suspense from '../../services/lazyLoad/Suspense';

const StateLocalForecasts = React.lazy(() => import('./StateLocalForecasts'));
const StateLocalForecastsDetails = React.lazy(() => import('./StateLocalForecastDetails'));

export default function StateLocalForecastsWrapper() {
  return (
    <Suspense>
      <AddToPipelineProvider scope={SCOPE_STATE_LOCAL_FORECASTS}>
        <Switch>
          <Route exact path={ROUTE_STATE_LOCAL_FORECASTS_DETAILS.path}>
            <StateLocalForecastsDetails />
          </Route>
          <Route exact path={ROUTE_STATE_LOCAL_FORECASTS.path}>
            <StateLocalForecasts />
          </Route>

          <Redirect exact path="/*" to={ROUTE_STATE_LOCAL_FORECASTS.path} />
        </Switch>

        <AddToPipelineConsumer />
      </AddToPipelineProvider>
    </Suspense>
  );
}
